// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1LinkedWorkItemResourceSchema } from './v1/linkedWorkItemResourceSchema';
import { v1LinkedWorkItemsUpdateSchema } from './v1/linkedWorkItems/updateSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const upsertLinkedWorkItemPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  external_id: z.coerce.string().describe("Customer-provided identifier (e.g. ABC-123)"),
});

export const upsertLinkedWorkItemHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Linked work item updated
 */
export const upsertLinkedWorkItem200Schema = z.lazy(() => v1LinkedWorkItemResourceSchema);

/**
 * @description Linked work item created
 */
export const upsertLinkedWorkItem201Schema = z.lazy(() => v1LinkedWorkItemResourceSchema);

/**
 * @description Unauthorized
 */
export const upsertLinkedWorkItem401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Forbidden - api_linked_work feature not enabled
 */
export const upsertLinkedWorkItem403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Validation failed - blank title
 */
export const upsertLinkedWorkItem422Schema = z.lazy(() => v1ValidationErrorSchema);

export const upsertLinkedWorkItemMutationRequestSchema = z.lazy(() => v1LinkedWorkItemsUpdateSchema);

export const upsertLinkedWorkItemMutationResponseSchema = z.lazy(() => upsertLinkedWorkItem200Schema);
